import Page from '../page';
import HomeNavigation from '../navigation/home-navigation';

import Home from '../pages/home.vue';

const HomePages = [
    {
        path: '/',
        components: {
            default: Page,
            'sidebar-nav': HomeNavigation
        },
        children: [
            {
                path: '',
                component: Home
            }
        ]
    }
];

export default HomePages;



// WEBPACK FOOTER //
// ./demo/routes/home.js